import styles from '../Tabelas.module.css'
import Container from '../../../../components/components-ui/Container/Container'
import { Table } from '../../../../components/Table'
import Button from '../../../../components/components-ui/Button/Button'
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import api from '../../../../services/Api'
import Loading from '../../../../components/components-ui/Loading/Loading'

export default function Estabelecimento() {
  const [listaCidade, setListaCidade] = useState([])
  const [showLoading, setShowLoading] = useState(false)

  useEffect(() => {
    async function getCidade() {
      setShowLoading(true)
      const response = await api.get('/cidade/index')
      setListaCidade(response.data)
      setShowLoading(false)
    }
    getCidade()
  }, [])

  // Colunas da tabela
  const columns = [
    {
      column: 'Cidade',
    },
  ]

  return (
    <Container>
      <h3>Listagem de Cidade</h3>
      <Link to="/usina/cidade/novo/" style={{ display: "contents" }}>
        <Button title="Novo" type="button" />
      </Link>

      <div className={styles.content}>
        <Table edit columns={columns}>
          {listaCidade.map(({ IDCidade, Cidade }) => (
            <tr key={IDCidade}>
              <td>
                <Link to={`/usina/cidade/edit/${IDCidade}`}>
                  <i className="fas fa-pencil-alt"></i>
                </Link>
              </td>
              <td>{Cidade}</td>
            </tr>
          ))}
        </Table>
        <div className={styles.loading}>
          <Loading display={showLoading ? 'block' : 'none'} />
        </div>
      </div>
    </Container>
  )
}
